import {EventEmitter, Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import { PharmacieDto } from '../DTO/pharmacie.dto';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public static API_ENDPOINT = environment.API_ENDPOINT;

  /**
   * Indique si les données du serveur ont été chargé ou non.
   * Est utilisé notamment pour savoir si le template peut être affiché ou non selon si l'utilisateur est connecté via le serveur CAS ou non
   * @type {boolean}
   */
  isDataLoaded = false;

  pharmacie: PharmacieDto;
  pharmacieActifchange: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  emitPharmacieActifEvent(actifBoolean) {
    this.pharmacieActifchange.emit(actifBoolean);
  }
  getPharmacieActifEmitter() {
    return this.pharmacieActifchange;
  }

  public setPharmacie(value: PharmacieDto) {
    this.pharmacie = value;
  }
}
